import loadable from '@loadable/component'
import {getRouter} from 'hiya-common/src/routes'

import FamilySpeed from './FamilySpeed'
import FightMonster from './FightMonster'
import HiyaFarm2022 from './HiyaFarm2022'
import LudoGame from './LudoGame'
import RoomPartyGift from './RoomPartyGift'
import WorldCup2022 from './WorldCup2022'
import Xmas2021 from './Xmas2021'
import NewYearUnionGame from './NewYearUnionGame'
import chat from './chat'
import NewYearUnionGameV2 from './NewYearUnionGameV2'

const routes = getRouter([
  ...chat,
  ...NewYearUnionGame,
  ...NewYearUnionGameV2,
  // 这里的webpackChunkName不要忘记修改
  // {
  //   path: '/network',
  //   exact: true,
  //   component: loadable(
  //     () => import(/* webpackChunkName: "page-network" */ '~/pages/network')
  //   ),
  // },
  {
    path: '/atm',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-ATM" */ '~/pages/ATM')
    ),
  },
  {
    path: '/atm/sign',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-ATM-signPop" */ '~/pages/ATM/signPop')
    ),
  },
  {
    path: '/TrMonthlyAnchor',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TrMonthlyAnchor" */ '~/pages/TrMonthlyAnchor'
        )
    ),
  },
  {
    path: '/GreedyRecharge',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-GreedyRecharge" */ '~/pages/GreedyRecharge'
        )
    ),
  },
  {
    path: '/GreedyJackpot',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-GreedyJackpot" */ '~/pages/GreedyJackpot'
        )
    ),
  },
  {
    path: '/AnnualAnchor',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnnualAnchor" */ '~/pages/AnnualAnchor'
        )
    ),
  },
  {
    path: '/NewYearActivityModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewYearActivityModal" */ '~/pages/ToyBricks/CustomComponents/NewYearActivity/Modal'
        )
    ),
  },
  {
    path: '/RightDiscountSale',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-RightDiscountSale" */ '~/pages/RightDiscountSale'
        )
    ),
  },
  {
    path: '/RaiseAFlag',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-RaiseAFlag" */ '~/pages/RaiseAFlag')
    ),
  },

  {
    path: '/ranktask',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-RankTask" */ '~/pages/rankTask')
    ),
  },
  {
    path: '/rankTask/entrance',
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-RankTaskEntrance" */ '~/pages/rankTask/entrance'
        )
    ),
    exact: true,
  },
  {
    path: '/GiftsBlindBox',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-GiftsBlindBox" */ '~/pages/GiftsBlindBox'
        )
    ),
  },

  {
    path: '/LuxuryCarFair',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-LuxuryCarFair" */ '~/pages/LuxuryCarFair'
        )
    ),
  },

  {
    path: '/FamilyPK',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-FamilyPK" */ '~/pages/FamilyPK')
    ),
  },

  {
    path: '/crossroompk/undertake',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CrossRoomPkUndertake" */ '~/pages/CrossRoomPkUndertake'
        )
    ),
  },

  {
    // 印巴换皮版本
    path: '/unionbattlea',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-UnionBattleA" */ '~/pages/UnionBattleA'
        )
    ),
  },
  {
    // 中东换皮版本
    path: '/unionbattleaAr',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-UnionBattleAAr" */ '~/pages/UnionBattleAAr'
        )
    ),
  },

  {
    path: '/recharge',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-Recharge" */ '~/pages/recharge')
    ),
  },
  {
    path: '/WeekGiftStar',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-WeekGiftStar" */ '~/pages/WeekGiftStar'
        )
    ),
  },
  {
    path: '/LuckRank',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-LuckRank" */ '~/pages/LuckRank')
    ),
  },
  {
    path: '/coinagencyrank',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Coinagencyrank" */ '~/pages/CoinagencyRank'
        )
    ),
  },
  {
    path: '/LuxuryCarAuction',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-LuxuryCarAuction" */ '~/pages/LuxuryCarAuction'
        )
    ),
  },
  {
    path: '/PartnerPlanSpring',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-PartnerPlanSpring" */ '~/pages/PartnerPlan/PartnerPlanSpring'
        )
    ),
  },
  {
    path: '/PartnerPlanSummer',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-PartnerPlanSummer" */ '~/pages/PartnerPlan/PartnerPlanSummer'
        )
    ),
  },
  {
    path: '/PartnerPlanAutumn',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-PartnerPlanAutumn" */ '~/pages/PartnerPlan/PartnerPlanAutumn'
        )
    ),
  },
  {
    path: '/PartnerPlanGreen',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-PartnerPlanGreen" */ '~/pages/PartnerPlan/PartnerPlanGreen'
        )
    ),
  },
  {
    path: '/PartnerPlanTRDay',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-PartnerPlanTRDay" */ '~/pages/PartnerPlan/PartnerPlanTRDay'
        )
    ),
  },
  {
    path: '/PartnerPlanWinter',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-PartnerPlanWinter" */ '~/pages/PartnerPlan/PartnerPlanWinter'
        )
    ),
  },
  {
    path: '/PartnerPlanNewYear',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-PartnerPlanNewYear" */ '~/pages/PartnerPlan/PartnerPlanNewYear'
        )
    ),
  },
  {
    path: '/AnchorTask',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-AnchorTask" */ '~/pages/AnchorTask')
    ),
  },
  {
    path: '/Valentine2022',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Valentine2022" */ '~/pages/Valentine2022'
        )
    ),
  },
  {
    path: '/luckydraw',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-HiyaLuckyDraw" */ '~/pages/HiyaLuckyDraw'
        )
    ),
  },
  ...FightMonster,
  ...HiyaFarm2022,
  ...LudoGame,
  {
    path: '/BigRRechargeTask',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-BigRRechargeTask" */ '~/pages/BigRRechargeTask'
        )
    ),
  },
  {
    // 印巴Room bonus房间收礼活动
    path: '/RoomBonus',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-RoomBonus" */ '~/pages/RoomBonus')
    ),
  },

  // 路由卸载页面
  // {
  //   path: '/IndianIPL',
  //   exact: true,
  //   component: loadable(
  //     () => import(/* webpackChunkName: "page-IndianIPL" */ '~/pages/IndianIPL')
  //   ),
  // },
  // {
  //   path: '/TerritoryBattle',
  //   exact: true,
  //   component: loadable(
  //     () =>
  //       import(
  //         /* webpackChunkName: "page-TerritoryBattle" */ '~/pages/TerritoryBattle'
  //       )
  //   ),
  // },
  // {
  //   path: '/WildBlindBox',
  //   exact: true,
  //   component: loadable(
  //     () =>
  //       import(
  //         /* webpackChunkName: "page-WildBlindBox" */ '~/pages/WildBlindBox'
  //       )
  //   ),
  // },
  {
    path: '/StarWars',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-StarWars" */ '~/pages/StarWars')
    ),
  },
  {
    path: '/AnnualIndividualPK',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnnualIndividualPK" */ '~/pages/AnnualIndividualPK'
        )
    ),
  },
  // {
  //   path: '/NewYear2021',
  //   exact: true,
  //   component: loadable(
  //     () =>
  //       import(/* webpackChunkName: "page-NewYear2021" */ '~/pages/NewYear2021')
  //   ),
  // },
  // {
  //   // 被改造成春节活动
  //   path: '/lohri',
  //   exact: true,
  //   component: loadable(
  //     () => import(/* webpackChunkName: "page-Lohri" */ '~/pages/Lohri')
  //   ),
  // },
  // 家族竞速赛
  // ...FamilySpeed,
  ...Xmas2021,

  {
    path: '/ToyBricksEdit',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-ToyBricksEdit" */ '~/pages/ToyBricks/edit'
        )
    ),
  },
  {
    path: '/ToyBricksView/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-ToyBricksView" */ '~/pages/ToyBricks/view'
        )
    ),
  },
  {
    path: '/WelcomeTasks',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-WelcomeTasks" */ '~/pages/WelcomeTasks'
        )
    ),
  },
  {
    path: '/WelcomeTasks/taskDetail',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-WelcomeTasks-TaskDetail" */ '~/pages/WelcomeTasks/TaskDetail'
        )
    ),
  },
  {
    path: '/AggregateBanner/:id?',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AggregateBanner" */ '~/pages/AggregateBanner'
        )
    ),
  },
  {
    path: '/PollyBanners',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-PollyBanners" */ '~/pages/AggregateBanner/PollyBanners'
        )
    ),
  },
  {
    path: '/castlecrush',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-CastleCrush" */ '~/pages/CastleCrush')
    ),
  },
  {
    path: '/LasserBairam/RewardToast',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-RewardToast" */ '~/pages/LasserBairam/RewardToast'
        )
    ),
  },
  {
    path: '/ludo/rank',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-LudoRank" */ '~/pages/LudoRank')
    ),
  },
  {
    path: '/Corban',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-Corban" */ '~/pages/Corban')
    ),
  },
  {
    path: '/HitAnimalsModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-HitAnimalsModal" */ '~/pages/HitAnimalsModal'
        )
    ),
  },
  {
    path: '/TopRoom',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-TopRoom" */ '~/pages/TopRoom')
    ),
  },
  {
    path: '/IdsIndependDayModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-HitAnimalsModal" */ '~/pages/IdsIndependDayModal'
        )
    ),
  },
  {
    path: '/ZaiShengJie2023Modal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-ZaiShengJie2023Modal" */ '~/pages/ZaiShengJie2023Modal'
        )
    ),
  },
  {
    path: '/GoodsSale',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-GoodsSale" */ '~/pages/GoodsSale')
    ),
  },
  {
    path: '/ElephantModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-ElephantModal" */ '~/pages/ElephantModal'
        )
    ),
  },
  {
    path: '/CrazyRecharge',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CrazyRecharge" */ '~/pages/ToyBricks/CustomComponents/CrazyRecharge/Task'
        )
    ),
  },
  {
    path: '/CrazyRecharge/Award',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CrazyRecharge" */ '~/pages/ToyBricks/CustomComponents/CrazyRecharge/Award'
        )
    ),
  },
  ...RoomPartyGift,
  {
    // 针对facebook限制的改密码表单页面
    path: '/ResetPassWord',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-ResetPassWod" */ '~/pages/ResetPassWord'
        )
    ),
  },
  {
    // 广播规则页面
    path: '/BroadcastRule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-BroadcastRule" */ '~/pages/BroadcastRule'
        )
    ),
  },
  {
    // 大富翁
    path: '/LuckyGuy',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-LuckyGuy" */ '~/pages/LuckyGuy')
    ),
  },
  {
    // 沙特国庆日爆奖弹窗
    path: '/SaudiNationalDayModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-SaudiNationalDayModal" */ '~/pages/ToyBricks/CustomComponents/QatarNationalDay/Modal'
        )
    ),
  },
  {
    // 家族教育弹窗
    path: '/FamilyEdu',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-FamilyEdu" */ '~/pages/FamilyEdu')
    ),
  },
  {
    // 沙特国庆日爆奖弹窗
    path: '/SaudiDayModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-SaudiDayModal" */ '~/pages/ToyBricks/CustomComponents/SaudiDay/Modal'
        )
    ),
  },
  ...WorldCup2022,
  {
    // 歌房PK弹窗
    path: '/SongRoomPk',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-SongRoomPk" */ '~/pages/SongRoomPk')
    ),
  },
  {
    // 年度盘点
    path: '/AnnualSum2022',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnnualSum2022" */ '~/pages/AnnualSum2022'
        )
    ),
  },
  {
    // 活动中心
    path: '/ActivityCenter',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-ActivityCenter" */ '~/pages/ActivityCenter'
        )
    ),
  },
  {
    // 农历新年2022
    path: '/LunarNewYear2022',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-LunarNewYear2022" */ '~/pages/LunarNewYear2022'
        )
    ),
  },
  {
    // 农历新年2023
    path: '/LunarNewYear2023',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-LunarNewYear2023" */ '~/pages/LunarNewYear2023'
        )
    ),
  },
  {
    // 公会拉新主播
    path: '/StarHunter',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-StarHunter" */ '~/pages/StarHunter')
    ),
  },
  {
    // 洒红节爆奖弹窗
    path: '/SaHongJieModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-SaHongJieModal" */ '~/pages/ToyBricks/CustomComponents/SaHongJieModal'
        )
    ),
  },
  {
    // 印尼独立日爆奖弹窗
    path: '/IndiaRewardModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-SaHongJieModal" */ '~/pages/RewardModal/IndiaRewardModal'
        )
    ),
  },
  {
    path: '/RamadanActive',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-RamadanActive" */ '~/pages/RamadanActive'
        )
    ),
  },
  {
    path: '/ViThYearPkBanner',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-RamadanActive" */ '~/pages/DynamicBanner/ViThYearPkBanner'
        )
    ),
  },
  {
    path: '/CakeModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CakeModal" */ '~/pages/ToyBricks/CustomComponents/CakeHappy/CakeModal'
        )
    ),
  },
  {
    path: '/RamadanSheep',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-RamadanSheep-main" */ '~/pages/RamadanSheep'
        )
    ),
  },
  {
    path: '/RamadanSheep2025',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-RamadanSheep2025-main" */ '~/pages/RamadanSheep2025'
        )
    ),
  },
  {
    path: '/ActivityCenterNew',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-ActivityCenterNew" */ '~/pages/ActivityCenterNew'
        )
    ),
  },
  {
    path: '/Ramadan2024',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Ramadan2024-Main" */ '~/pages/Ramadan2024/Main'
        )
    ),
  },
  {
    path: '/HallOfFame',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-HallOfFame" */ '~/pages/HallOfFame')
    ),
  },
  {
    path: '/FastingDay',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-ToyBricksEdit" */ '~/pages/FastingDay'
        )
    ),
  },
  {
    path: '/RoomPoolAward',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-FastingDay-RoomPoolAward" */ '~/pages/FastingDay/RoomPoolAward'
        )
    ),
  },
  {
    path: '/FastingDay/RoomBanner',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-game-GreedyHiya-banner" */ '~/pages/FastingDay/RoomBanner'
        )
    ),
  },
  {
    path: '/NewUnionAnchor',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewUnionAnchor" */ '~/pages/NewUnionAnchor'
        )
    ),
  },
  {
    path: '/AnniversaryGiftTrigger',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnniversaryGift" */ '~/pages/ToyBricks/CustomComponents/AnniversaryGift'
        )
    ),
  },
  {
    path: '/FLBIndependenceDayTrigger',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-FLBIndependenceDay" */ '~/pages/ToyBricks/CustomComponents/FLBIndependenceDay'
        )
    ),
  },
  {
    path: '/PartnerPlanAnniversary',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-PartnerPlanAnniversary" */ '~/pages/PartnerPlan/PartnerPlanAnniversary'
        )
    ),
  },
  {
    path: '/WaterLanternDayModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-WaterLanternDayModal" */ '~/pages/WaterLanternDayModal'
        )
    ),
  },
  {
    path: '/HalloweenModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-HalloweenModal" */ '~/pages/ToyBricks/CustomComponents/Halloween/components/modal'
        )
    ),
  },
  {
    path: '/AnnualGameGiftBanner',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnnualGameGiftBanner" */ '~/pages/ToyBricks/CustomComponents/AnnualGameGift/GiftBanner'
        )
    ),
  },
  {
    path: '/GreedyRechargeNew',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-GreedyRechargeNew" */ '~/pages/GreedyRechargeNew'
        )
    ),
  },
  {
    path: '/FriendSearch',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-FriendSearch" */ '~/pages/FriendSearch'
        )
    ),
  },
  {
    path: '/AnnualGameBlueSkyBanner',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnnualGameBlueSkyBanner" */ '~/pages/ToyBricks/CustomComponents/AnnualGameBlueSky/GiftBanner'
        )
    ),
  },
  {
    path: '/AnnualGameBlueSkyBannerV2',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnnualGameBlueSkyBannerV2" */ '~/pages/ToyBricks/CustomComponents/AnnualGameBlueSkyV2/GiftBanner'
        )
    ),
  },
  {
    path: '/HolyWeekModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-HolyWeekModal" */ '~/pages/ToyBricks/CustomComponents/HolyWeek/BounsToast'
        )
    ),
  },
  {
    path: '/HolyWeekGuide',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-HolyWeekGuide" */ '~/pages/ToyBricks/CustomComponents/HolyWeek/GuideToast'
        )
    ),
  },
  {
    path: '/SlaughterAnimalModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-SlaughterAnimalModal" */ '~/pages/ToyBricks/CustomComponents/SlaughterAnimal/components/BounsToast'
        )
    ),
  },
  {
    // 公会拉新主播 - 新增上麦任务
    path: '/StarHunterV2',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-StarHunterV2" */ '~/pages/StarHunterV2'
        )
    ),
  },
  {
    path: '/AnnualGameBlueSkyBannerV3',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnnualGameBlueSkyBannerV3" */ '~/pages/ToyBricks/CustomComponents/AnnualGameBlueSkyV3/GiftBanner'
        )
    ),
  },
  {
    path: '/PkIndependenceDayTrigger',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-PkIndependenceDay" */ '~/pages/ToyBricks/CustomComponents/PkIndependenceDay'
        )
    ),
  },
  {
    path: '/TreasureHunt',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TreasureHunt" */ '~/pages/TreasureHunt'
        )
    ),
  },
  {
    path: '/TreasureHunt/Activity',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TreasureHunt-Activity" */ '~/pages/TreasureHunt/components/Activity'
        )
    ),
  },
  {
    path: '/TreasureHunt/Review',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TreasureHunt-Review" */ '~/pages/TreasureHunt/components/Review'
        )
    ),
  },
  {
    path: '/TreasureHunt/Banner',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TreasureHunt-Banner" */ '~/pages/TreasureHunt/Banner'
        )
    ),
  },
  {
    path: '/TreasureHunt/Promotional',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TreasureHunt-PromotionalModal" */ '~/pages/TreasureHunt/components/Modal/Promotional'
        )
    ),
  },
  {
    path: '/TreasureHunt/Free',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TreasureHunt-Free" */ '~/pages/TreasureHunt/components/Modal/Free'
        )
    ),
  },
  {
    path: '/CoffeeDivinationBanner',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CoffeeDivinationBanner" */ '~/pages/ToyBricks/CustomComponents/CoffeeDivination/banner'
        )
    ),
  },
  {
    path: '/PrizePoolDividend',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-PrizePoolDividend" */ '~/pages/PrizePoolDividend'
        )
    ),
  },
  {
    path: '/PrizePoolDividend/Banner',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-PrizePoolDividend-Banner" */ '~/pages/PrizePoolDividend/Banner'
        )
    ),
  },
  {
    path: '/PrizePoolDividend/Promotional',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-PrizePoolDividend-Promotional" */ '~/pages/PrizePoolDividend/Promotional'
        )
    ),
  },
  {
    path: '/HallOfFame2025YearModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-HallOfFame2025YearModal" */ '~/pages/ToyBricks/CustomComponents/HallOfFame2025Year/modal'
        )
    ),
  },
  {
    path: '/Celebrity2025YearModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Celebrity2025YearModal" */ '~/pages/ToyBricks/CustomComponents/Celebrity2025Year/modal'
        )
    ),
  },
  {
    path: '/AnchorGame2025Modal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorGame2025Modal" */ '~/pages/ToyBricks/CustomComponents/AnchorGame2025/components/animateModal'
        )
    ),
  },
  {
    path: '/AnchorGame2025Banner',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorGame2025Modal" */ '~/pages/ToyBricks/CustomComponents/AnchorGame2025/Banner'
        )
    ),
  },
  {
    path: '/AnnualRecharge2025PendantPop',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnnualRecharge2025PendantPop" */ '~/pages/ToyBricks/CustomComponents/AnnualRecharge2025/PendantPop'
        )
    ),
  },
  {
    path: '/YearInfluence2025/Promotional',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-YearInfluence2025-Promotional" */ '~/pages/ToyBricks/CustomComponents/YearInfluence2025/PendantPop/Promotional'
        )
    ),
  },
  {
    path: '/YearInfluence2025/Invitation',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-YearInfluence2025-Invitation" */ '~/pages/ToyBricks/CustomComponents/YearInfluence2025/PendantPop/Invitation'
        )
    ),
  },
  {
    path: '/FengKuangDayModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-FengKuangDay-Modal" */ '~/pages/ToyBricks/CustomComponents/FengKuangDay/fengkuangmodal'
        )
    ),
  },
  {
    path: '/NewYear2026Modal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorGame2025Modal" */ '~/pages/ToyBricks/CustomComponents/NewYear2026/components/PrizeModal'
        )
    ),
  },
  {
    path: '/NewYear2026AnimateModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnchorGame2025Modal" */ '~/pages/ToyBricks/CustomComponents/NewYear2026/components/animateModal'
        )
    ),
  },
  {
    path: '/RedEnvelope',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-RedEnvelopeSend2026-RedEnvelope" */ '~/pages/ToyBricks/CustomComponents/RedEnvelopeSend2026/components/Modal/RedEnvelope'
        )
    ),
  },
  {
    path: '/UnionBonusCardModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-UnionBonusCard-Modal" */ '~/pages/ToyBricks/CustomComponents/UnionBonusCard/UnionBonusCardModal'
        )
    ),
  },
  {
    path: '/CiShanJia2026RoomPage',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-cishanjia-room" */ '~/pages/ToyBricks/CustomComponents/CiShanJia2026/CishanjiaPage/RoomPage'
        )
    ),
  },
  {
    path: '/CiShanJia2026GiftBanner',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CiShanJia2026-GiftBanner" */ '~/pages/ToyBricks/CustomComponents/CiShanJia2026/Cishanjia/GiftBanner'
        )
    ),
  },
  {
    path: '/CricketWarsV2Modal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CricketWarsV2Modal" */ '~/pages/ToyBricks/CustomComponents/CricketWarsV2/WinnerModal'
        )
    ),
  },
  {
    path: '/Puzzle24Promotional',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Puzzle24" */ '~/pages/ToyBricks/CustomComponents/Puzzle24/components/Modal/Promotional'
        )
    ),
  },
  {
    path: '/AnnualGameGiftBanner2026',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnnualGameGiftBanner2026" */ '~/pages/ToyBricks/CustomComponents/AnnualGameGift2026/GiftBanner'
        )
    ),
  },
  {
    path: '/TreasureHuntV2',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TreasureHuntV2" */ '~/pages/TreasureHuntV2'
        )
    ),
  },
  {
    path: '/TreasureHuntV2/Activity',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TreasureHuntV2-Activity" */ '~/pages/TreasureHuntV2/components/Activity'
        )
    ),
  },
  {
    path: '/TreasureHuntV2/Review',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TreasureHuntV2-Review" */ '~/pages/TreasureHuntV2/components/Review'
        )
    ),
  },
  {
    path: '/TreasureHuntV2/Banner',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TreasureHuntV2-Banner" */ '~/pages/TreasureHuntV2/Banner'
        )
    ),
  },
  {
    path: '/TreasureHuntV2/Promotional',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TreasureHuntV2-PromotionalModal" */ '~/pages/TreasureHuntV2/components/Modal/Promotional'
        )
    ),
  },
  {
    path: '/TreasureHuntV2/Free',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TreasureHuntV2-Free" */ '~/pages/TreasureHuntV2/components/Modal/Free'
        )
    ),
  },
  {
    path: '/TreasureHuntV2/TreasureChest',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TreasureHuntV2-TreasureChest" */ '~/pages/TreasureHuntV2/components/Modal/TreasureChest'
        )
    ),
  },
  {
    path: '/LFPage',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-LuckFomoPage" */ '~/pages/LuckFomo')
    ),
  },
  {
    path: '/LFRule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-LuckFomoRule" */ '~/pages/LuckFomo/pages/Rule'
        )
    ),
  },
  {
    path: '/LFModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-LuckFomoModal" */ '~/pages/LuckFomo/pages/Modal'
        )
    ),
  },
  {
    path: '/CPPage',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-CPPage" */ '~/pages/CPRelation')
    ),
  },
  {
    path: '/CPRank',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CPRank" */ '~/pages/CPRelation/pages/Rank'
        )
    ),
  },
  {
    path: '/CPRule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CPRule" */ '~/pages/CPRelation/pages/Rule'
        )
    ),
  },
  {
    path: '/CPNormalBanner',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CPNormalBanner" */ '~/pages/CPRelation/pages/NormalBanner'
        )
    ),
  },
  {
    path: '/CPSpecialBanner',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CPSpecialBanner" */ '~/pages/CPRelation/pages/SpecialBanner'
        )
    ),
  },
  {
    path: '/CPRoomModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CPRoomModal" */ '~/pages/CPRelation/pages/RoomModal'
        )
    ),
  },
  {
    path: '/SpinNewUserShare',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-SpinNewUser-SpinNewUserShare" */ '~/pages/ToyBricks/CustomComponents/SpinNewUser/Share'
        )
    ),
  },
  {
    path: '/SpinNewUser/Promotional',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-SpinNewUser-SpinPromoModal" */ '~/pages/ToyBricks/CustomComponents/SpinNewUser/SpinPromoModal'
        )
    ),
  },
  {
    path: '/UnionPkRoomModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-UnionPkRoomModal" */ '~/pages/ToyBricks/CustomComponents/AnchorTeamPk/pages/RoomModal'
        )
    ),
  },
  {
    path: '/UnionPkUpgradeModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-UnionPkUpgradeModal" */ '~/pages/ToyBricks/CustomComponents/AnchorTeamPk/pages/UpgradeModal'
        )
    ),
  },
  {
    path: '/CricketWarsV4Modal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CricketWarsV4Modal" */ '~/pages/ToyBricks/CustomComponents/CricketWarsV4/WinnerModal'
        )
    ),
  },
  {
    path: '/WorldCup/Promotional',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-WorldCup-Promotional" */ '~/pages/ToyBricks/CustomComponents/WorldCup/components/WorldCupPromoModal'
        )
    ),
  },
  {
    path: '/MidYearAggregation/Promotional',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-MidYearAggregation" */ '~/pages/ToyBricks/CustomComponents/MidYearAggregation/components/ReservationOpenModal'
        )
    ),
  },
  {
    path: '/MidYearAggregation',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-MidYearAggregation" */ '~/pages/ToyBricks/CustomComponents/MidYearAggregation/index'
        )
    ),
  },
  {
    path: '/WordCupCarnival/RoomModal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-WordCupCarnival" */ '~/pages/ToyBricks/CustomComponents/WordCupCarnival/pages/RoomModal'
        )
    ),
  },
])

// // eslint-disable-next-line @typescript-eslint/no-unused-vars
export default (store) => routes
// export default (store) =>
//   getRouter([
//     {
//       path: '/FengKuangDayModal',
//       exact: true,
//       component: loadable(
//         () =>
//           import(
//             /* webpackChunkName: "page-FengKuangDay-Modal" */ '~/pages/ToyBricks/CustomComponents/FengKuangDay/fengkuangmodal'
//           )
//       ),
//     },
//     {
//       path: '/ToyBricksEdit',
//       exact: true,
//       component: loadable(
//         () =>
//           import(
//             /* webpackChunkName: "page-ToyBricksEdit" */ '~/pages/ToyBricks/edit'
//           )
//       ),
//     },
//     {
//       path: '/ToyBricksView/:id',
//       exact: true,
//       component: loadable(
//         () =>
//           import(
//             /* webpackChunkName: "page-ToyBricksView" */ '~/pages/ToyBricks/view'
//           )
//       ),
//     },
//   ])
